export default __webpack_public_path__ + "static/media/twitter_icon.ee6c3893.svg";